// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const PreorderPad: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 28 28"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fillRule="evenodd"
                d="M17.688 0a3.241 3.241 0 013.237 3.237v.288h5.267c.995 0 1.808.81 1.808 1.805v20.862A1.81 1.81 0 0126.192 28H9.183c-.999 0-1.808-.81-1.808-1.808v-.845a7.836 7.836 0 010-15.645V5.33c0-.996.81-1.805 1.808-1.805h5.267v-.288A3.242 3.242 0 0117.688 0zM10.56 4.446H9.183a.886.886 0 00-.887.884v4.372a7.836 7.836 0 010 15.645v.845c0 .49.397.886.887.886h17.009c.49 0 .886-.396.886-.886V5.33a.886.886 0 00-.886-.884h-1.378v1.716a1.81 1.81 0 01-1.809 1.808H12.366a1.809 1.809 0 01-1.805-1.808V4.446zm14.226 16.34a.46.46 0 110 .922h-7.49a.46.46 0 010-.921zM11.82 17.849a.476.476 0 00-.595.326 3.53 3.53 0 01-2.929 2.522 2.97 2.97 0 01-.477.036c-.15 0-.297-.01-.444-.033a3.532 3.532 0 01-1.857-.839l1.197-1.193a.48.48 0 00.103-.522c-.055-.179-.23-.3-.442-.3H3.508a.485.485 0 00-.483.483v2.886c0 .193.115.368.295.446.06.022.124.034.185.034a.47.47 0 00.34-.14l1.014-1.015a4.525 4.525 0 002.516 1.133c.147.016.294.022.444.022a4.511 4.511 0 004.311-3.232c.094-.275-.057-.521-.31-.614zm12.967-.785a.46.46 0 110 .922h-6.21a.46.46 0 110-.922zM12.35 12.75a.483.483 0 00-.524.105l-1.012 1.012a4.501 4.501 0 00-2.98-1.152 4.506 4.506 0 00-4.311 3.232.481.481 0 00.926.27 3.537 3.537 0 012.925-2.507c.15-.026.304-.035.46-.035a3.56 3.56 0 012.302.87l-1.198 1.198a.476.476 0 00-.102.524c.074.18.25.294.445.294h2.884c.265-.015.483-.214.483-.48v-2.886a.481.481 0 00-.298-.445zm12.436.59a.46.46 0 110 .922h-7.49a.46.46 0 010-.921zm-.896-8.893H11.483v1.716c0 .489.396.887.883.887h10.64a.887.887 0 00.885-.887V4.446zM17.688.922a2.318 2.318 0 00-2.316 2.315v.288h4.632v-.288A2.319 2.319 0 0017.688.922z"
            />
        </svg>
    );
};

export default React.memo(PreorderPad);
